export const unitCompare = (a, b) =>
  String(a?.unit_number ?? "").localeCompare(String(b?.unit_number ?? ""), undefined, { numeric: true, sensitivity: "base" });

export const sortByUnit = (arr, dir = "asc") => {
  const s = [...(arr || [])].sort(unitCompare);
  return dir === "desc" ? s.reverse() : s;
};
